// extracted by mini-css-extract-plugin
module.exports = {"fieldset":"styles__fieldset___23mX_","legend":"styles__legend___2ms_D"};